<template>
    <v-form v-model="formValido" ref="formInterno">
        <div :key="componentKey">
            <div class="d-flex">
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[v => !!v || 'CNPJ é obrigatório']" 
                            clearable outlined label="CNPJ" v-model="objNf.cnpj" @blur="getCnpjInfo(objNf.cnpj)" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="8">
                        <v-text-field 
                            :rules="[
                                v => !!v || 'E-mail é obrigatório',
                                v => /.+@.+\..+/.test(v) || 'E-mail inválido'
                            ]"
                            clearable outlined label="Email" v-model="objNf.email" />
                    </v-col>
                </v-row>
            </div>

            <div>
                <v-row>
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.cep"
                            clearable
                            outlined
                            label="CEP"
                            :rules="[v => !!v || 'CEP é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.cidade"
                            clearable
                            outlined
                            label="Cidade"
                            :rules="[v => !!v || 'Cidade é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.codigoCidade"
                            clearable
                            outlined
                            label="Código da Cidade"
                            :rules="[v => !!v || 'Código é obrigatório']" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.logradouro"
                            clearable
                            outlined
                            label="Logradouro"
                            :rules="[v => !!v || 'Logradouro é obrigatório',]"
                        />
                    </v-col>
                    
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.bairro"
                            clearable
                            outlined
                            label="Bairro"
                            :rules="[v => !!v || 'Bairro é obrigatório',]"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.numero"
                            clearable
                            outlined
                            label="Número"
                        />
                    </v-col>

                </v-row>
            </div>

            <div>
                <v-row>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field
                            v-model="objNf.complemento"
                            clearable
                            outlined
                            label="Complemento"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[v => !!v || 'UF é obrigatório']"  
                            clearable outlined 
                            label="UF" 
                            v-model="objNf.uf" 
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-combobox 
                            label="Condições de Pagamento" 
                            v-model="objNf.condPag" 
                            :items="['á vista', 'parcelado']" 
                            outlined
                            clearable
                        ></v-combobox>
                    </v-col>

                    <v-col>
                        <v-combobox 
                            label="Meio de Pagamento" 
                            v-model="objNf.meioPagamento" 
                            :items="meioPagamentoOptions" 
                            outlined
                            clearable
                        ></v-combobox>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-autocomplete 
                            v-model="objNf.cfop"
                            :items="cfops" 
                            item-text="codigo"
                            item-value="codigo" 
                            label="CFOP" 
                            dense 
                            outlined
                            @change="selectedCfop"
                        >
                            <template v-slot:item="{ item }">
                                <div class="d-flex flex-column">
                                    <div class="font-weight-bold">{{ item.codigo }}</div>
                                    <div>{{ item.descricao }}</div>
                                </div>
                            </template>
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            clearable 
                            outlined 
                            label="Natureza de Operação" 
                            v-model="objNf.naturezaOp" 
                            readonly
                            :key="componentKey"
                        />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-combobox 
                            v-model="objNf.operacaoFiscal"
                            :items="operacaoFiscalOptions" 
                            label="Operação Fiscal" 
                            dense 
                            outlined
                            readonly
                        ></v-combobox>
                    </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete 
                                v-model="objNf.ncm"
                                :items="itemsNcm" 
                                item-text="codigo"
                                item-value="codigo" 
                                label="NCM" 
                                dense 
                                outlined
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.codigo }}</div>
                                        <div>{{ item.descricao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                        <v-col cols="12" sm="6" md="4">
                            <v-autocomplete 
                                v-model="objNf.cest"
                                :items="cests" 
                                item-text="codigo"
                                item-value="codigo" 
                                label="CEST" 
                                dense 
                                outlined
                            >
                                <template v-slot:item="{ item }">
                                    <div class="d-flex flex-column">
                                        <div class="font-weight-bold">{{ item.codigo }}</div>
                                        <div>{{ item.descricao }}</div>
                                    </div>
                                </template>
                            </v-autocomplete>
                        </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            type="date" 
                            clearable 
                            outlined 
                            label="Data de Vencimento" 
                            v-model="objNf.dataSaida" 
                        />
                    </v-col>
                </v-row>

            </div>

        </div>

        <div class="d-flex align-center">
            <v-checkbox v-model="objNf.addRetirada" />
            <label>Adicionar Informações de Retirada/Entrega</label>
        </div>
        
        <v-card>
            <v-card-title>
                Romaneios
            </v-card-title>
            <v-autocomplete 
                v-model="objNf.romaneio" 
                :items="romaneios" 
                item-text="codigo"
                item-value="_id" 
                label="Romaneio" 
                dense 
                chips
                outlined 
                multiple
                return-object
            >
            </v-autocomplete>
        </v-card>
            

        <div class="mb-5 mt-5" v-if="objNf.condPag == 'parcelado'">
            <v-card>
                <v-card-title>
                    Parcelas - {{ sumParcelas()?.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) }} - {{ valorNota / 100 }}
                </v-card-title>

                <div>
                <v-row dense v-for="parcela in parcelas" :key="parcela.numParcela">
                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="N° Parcela" v-model="parcela.numParcela" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field clearable outlined label="Data de Vencimento" type="date" v-model="parcela.vencimento" />
                    </v-col>

                    <v-col cols="12" sm="6" md="4">
                        <v-text-field 
                            :rules="[
                                v => {
                                    const valor = valorNota ? Number(String(valorNota)?.replace(/\./g, '')?.replace(',', '.')) / 100 : 0
                                    return valor >= sumParcelas() || 'Não pode ultrapassar a parcela'
                                }
                            ]"
                            clearable outlined label="Valor da Parcela" 
                            v-money="money" 
                            v-model="parcela.vrlParcela" 
                        />
                    </v-col>

                    <!-- Botão com ícone ao final -->
                    <v-col cols="12" sm="6" md="4" >
                        <v-btn color="primary" icon @click="addParcela()" v-if="Number(String(valorNota)?.replace(/\./g, '')?.replace(',', '.')) / 100 || 0 >= sumParcelas()">
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                        <v-btn color="error" icon @click="removeParcela(parcela)" v-if="parcelas.length >= 2">
                            <v-icon>mdi-minus</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
                </div>

            </v-card>
        </div>

        <v-card class="mb-5 mt-5">
            <v-card-title>
                Itens de Nota Fiscal
            </v-card-title>

            <TableItensNotaFiscal 
                :addItem="false"
                :readyall="true"
                :schemaName="'FisPreDocEmiItem'"
                :itemsByRomaneio="osItems"
                :open="openItem"
                :jobSelected="jobSelected"
                :isNfRemessa="isNfRemessa"
                :isNfReferenciada="isNfReferenciada"
                relation
                :ids="objNf.itens"
                :item="objNf.itens"
                @save-item="
                ($event) => {
                    arrayItems = $event;
                    this.sumItems();
                }"
            />
        </v-card>

        <v-card class="mt-5">
            <v-card-title bold>
                Transportadora
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="4" md="4">
                        <v-autocomplete 
                            v-model="objNf.transportadora" 
                            :items="transportadoras" 
                            item-text="razaoSocial"
                            item-value="id" 
                            label="Transpostadora" 
                            dense 
                            outlined 
                        >
                        </v-autocomplete>
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.quantidade" label="Quantidade" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.especie" label="Especie" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.marca" label="Marca" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.numeracao" label="Numeração" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.pesoBruto" v-mask="'####,####'" label="Peso Bruto KG" outlined />
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                        <v-text-field v-model="objNf.pesoLiquido" v-mask="'####,####'" label="Peso Liquido KG" outlined />
                    </v-col>

                </v-row>
            </v-card-text>
        </v-card>

        <v-card class="mt-5">
            <v-card-title bold>
                Informações Adicionais
            </v-card-title>
            <v-card-text>
                <v-textarea
                    v-model="objNf.informacaoAdd"
                    label="Informação Adionais"
                    outlined
                ></v-textarea>
            </v-card-text>
        </v-card>

        <v-expansion-panels multiple>
        </v-expansion-panels>
        
    </v-form>
</template>

<script>
import {VMoney} from 'v-money'
import Vue from 'vue';
import TableItensNotaFiscal from './TableItensNotaFiscal.vue';
export default {
    name: 'NotaFiscal',
    directives: { money: VMoney },
    props: ['projects', 'userInfo', 'item', 'pacelasCads', 'valorNota', 'jobSelected', 'romaneios', 'isNfRemessa', 'isNfReferenciada'],
    components: {
        TableItensNotaFiscal,
        //CreateItensNotaFiscalView: () => import('./CreateItensNotaFiscalView.vue')
    },
    data(){
        return {
            expasionInfoGerais: false,
            salesOrders: [],
            openItem: false,
            arrayItems: [],
            componentKey: 0,
            formValido: false,
            searchNotaChaveAcesso: '',
            osItems: [],
            transportadoras: [],
            cfops: [],
            itemsNcm: [],
            cests: [],
            operacaoFiscalOptions: ["Entrada", "Saída"],
            meioPagamentoOptions: [
                "Dinheiro",
                "Cheque",
                "Cartão de Crédito",
                "Cartão de Débito",
                "Cartão da Loja",
                "Vale Alimentação",
                "Vale Refeição",
                "Vale Presente",
                "Vale Combustível",
                "Boleto Bancário",
                "Depósito Bancário",
                "Pagamento Instantâneo (PIX) - Dinâmico",
                "Transferência bancária, Carteira Digital",
                "Programa de fidelidade, Cashback, Crédito Virtual",
                "Pagamento Instantâneo (PIX) - Estático",
                "Crédito em Loja",
                "Pagamento Eletrônico não Informado - falha de hardware do sistema emissor",
                "Sem pagamento",
                "Pagamento Posterior",
                "Outros"
            ],
            money: {
                locale: "pt-br",
                decimal: '.',
                thousands: '.',
                prefix: '',
                precision: 2,
                masked: false
            },
            parcelas: this.pacelasCads.length > 0 ?  this.pacelasCads : [
                { numParcela: '01', vencimento: null, vrlParcela: 0 }
            ],
            itemsData: [],
            objNf: {
                nomeDestinatario: null,
                dataSaida: null,
                cep: '',
                cidade: '',
                codigoCidade: '',
                logradouro: '',
                bairro: '',
                numero: '',
                complemento: '',
                status: '',
                naturezaOp: null,
                cnpj: null,
                uf: '',
                meioPagamento: '',
                defFiscais: null,
                ncm: null,
                cest: null,
                cfop: null,
                valorUnitario: 0,
                quantidade: 0,
                icms: null,
                baseIcms: null,
                valueIcms: null,
                condPag: '',
                job: '',
                os: '',
                romaneio: [],
                email: '',
                itens: [],
                notaFiscalMae: '',
                addRetirada: false,
                transportadora: '',
                pesoBruto: null,
                pesoLiquido: null,
                especie: null,
                marca: null,
                numeracao: null,
                valorFrete: 0,
                valorSeguro: 0,
                valorDesconto: 0,
                valorOutros: 0,
                informacaoAdd: ''
            }
        }
    },
    methods: {
        async getDataEntity(schemaName){
            const response = await Vue.prototype.$http.get(`/Entity/${schemaName}`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            });

            return response.data.data.data
        },

        addParcela(){
            this.parcelas.push({ 
                numParcela: String(this.parcelas.length + 1).padStart(2, '0'), 
                vencimento: null, 
                vrlParcela: 0 
            })  
        },

        async removeParcela(parcela){
            this.parcelas =  this.parcelas.filter((p) => p.numParcela != parcela.numParcela)

            if(parcela.id){
                await Vue.prototype.$http.delete(`/Entity/FisPreDocEmiFin?id=${parcela.id}`)
            }

        },

        sumParcelas(){
            let sum = 0
            this.parcelas?.map((p) => {
                if(p.vrlParcela) sum += Number(String(p?.vrlParcela)?.replace(/\./g, '')?.replace(',', '.') || 0)  / 100
            })

            return sum || 0
        },

        async getCnpjInfo(value){

            if(value?.length == 18){
                const response = await Vue.prototype.$http.post('/Action/run', 
                    { 
                        actionId: "128f5633-f624-41f8-abcf-043bc39a4bb7",
                        actionName: "Action info CNPJ",
                        params: { 
                            cnpj: value.replace(/\D/g, '')
                        } 
                    })


                if(response.data.data.data.status == "ERROR"){
                    this.$notfy.error("CNPJ invalido.");
                    // this.objNf.cpfOrCnpjEmitente = ''
                    return
                }

                const info = response.data.data.data

                this.objNf.uf = info.uf
                this.objNf.email = info.email

                this.objNf.bairro = info.bairro
                this.objNf.cidade = info.municipio
                this.objNf.logradouro = info.logradouro
                this.objNf.numero = info.numero
                this.objNf.cep = info.cep
                this.objNf.complemento = info.complemento

                this.componentKey += 1
            }
        },

        parseMoeda(valor) {
            if (!valor) return 0;

            valor = valor.toString().trim();

            // Caso especial: "395.039.30" -> "395039,30"
            const partes = valor.split(".");
            if (partes.length > 2 && !valor.includes(",")) {
                const decimal = partes.pop(); // pega o último como decimal
                valor = partes.join("") + "," + decimal; 
            }

            return parseFloat(
                valor.replace(/\./g, "")   // remove milhar
                    ?.replace(",", ".")    // vírgula -> ponto decimal
            ) || 0;
        },

        sumItems(){
            let sum = 0
            this.arrayItems?.map((item) => {
                console.log('valor total >>> ', item.valorTotal, this.parseMoeda(item.valorTotal))
                sum += Number(String(item.valorTotal)?.replace(/\./g, '')?.replace(',', '') || 0)
            })
            //console.log('sum itens ', sum)
            this.$emit('sumItens', sum)
        },

        getFisTipiOptions () {
            Vue.prototype.$http.get(`/Entity/FisTipi`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.fisTipiOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching FisTipi options:", error);
            });
        },

        getOperacaoFiscalOptions () {
            Vue.prototype.$http.get(`/Entity/FisOper`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.operacaoFiscalOptions = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching Operacao Fiscal options:", error);
            });
        },


        getNcms(){
            Vue.prototype.$http.get(`/Entity/NCM`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.itemsNcm = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching ncms options:", error);
            });
        },

        getCFOPs(){
            Vue.prototype.$http.get(`/Entity/CFOP/search-fields`, {
                params: {
                    page: 1,
                    limit: 9999,
                    searchFields: '[codigo]',
                    value: this.isNfRemessa ? '[5901,6901,5905,6905,5912,6912,5910,6910,5949]' : undefined
                }
            }).then(response => {
                this.cfops = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching cfops options:", error);
            });
        },

        getCests(){
            Vue.prototype.$http.get(`/Entity/CEST`, {
                params: {
                    page: 1,
                    limit: 9999
                }
            }).then(response => {
                this.cests = response.data.data.data;
            }).catch(error => {
                console.error("Error fetching cets options:", error);
            });
        },
        
        selectedCfop(value){
            const cfopSelected = this.cfops.filter((cfop) => cfop.codigo == value)[0] || []

            this.objNf.naturezaOp = cfopSelected?.descricao || ''
            this.objNf.operacaoFiscal = cfopSelected.operacaoFiscal

            this.componentKey += 1
        }
    },
    watch: {
        item: {
            async handler(value){
                this.objNf = value
            },
            deep: true,
            immediate: true
        },

        objNf: {
            handler(value){
                this.$emit('nf', value)
            },
            deep: true,
            immediate: true
        },

        ['item.itens']: {
            async handler(itens){
                if (itens?.length > 0) {
                    const response = await Vue.prototype.$http('/Entity/FisPreDocEmiItem/search-fields', {
                        params: {
                            ids: itens.map((item) => item).join(','),
                            sortField: 'sequencia'
                        }
                    })

                    this.arrayItems = response.data.data.data.data
                    this.osItems = response.data.data.data


                }
            },
            deep: true,
            immediate: true
        },

        ['item.romaneio']: {
            async handler(romaneio) {

                this.osItems = []

                if(romaneio?.length > 0){

                    this.objNf.transportadora = romaneio[0]?.transportadora || this.objNf.transportadora
                    this.objNf.quantidade = romaneio[0]?.quantidade || this.objNf.quantidade
                    this.objNf.numeracao = romaneio[0].numeracao
                    this.objNf.pesoLiquido = romaneio[0].pesoLiquido
                    this.objNf.pesoBruto = romaneio[0].pesoBruto
                    this.objNf.especie = romaneio[0].especie
                    this.objNf.marca = romaneio[0].marca

                    romaneio?.map((item) => {
                        item?.romaneiopackinglist?.map((romaneioPacking) => {
                            romaneioPacking.listaDeEmbarqueItem?.map((listEmbItem) => {
                                if(!this.isNfRemessa){
                                    this.osItems.push({ ...listEmbItem.ordemDeServico[0], unidadeSigla: listEmbItem.itenListPacking[0].ordemServico[0].unidadeSigla })
                                } else {
                                    listEmbItem.itenListPacking?.map((itenListPacking) => {
                                        //if(itenListPacking?.itemCaldeiraria){
                                            this.osItems.push(itenListPacking)
                                        //}
                                    })
                                }
                            })
                        })
                    })
                }

                // console.log("osItems ", this.osItems)
            },
            deep: true
        },

        async jobSelected(job){
            //console.log('JOB SELECTED >>> ', job.ncmCodigo, this.itemsNcm, this.itemsNcm.filter((ncm) => ncm.codigo === job.ncmCodigo))
            this.objNf.ncm = job.ncmCodigo

            const searchNcm = this.itemsNcm.filter((ncm) => ncm.codigo === job.ncmCodigo)[0]
            this.objNf.cest = this.cests.filter((cest) => cest.descricao === searchNcm?.descricao)[0]?.codigo
            this.objNf.cfop = job.cfopCodigo
            this.selectedCfop(job.cfopCodigo)
        },

        arrayItems: {
            handler(value){
                this.$emit('itens-nf', value)
            },
            immediate: true,
            deep: true
        },

        async expasionInfoGerais(value){
            // if(value && this.romaneios.length == 0){
            //     this.romaneios = await this.getDataEntity('Romaneio')
            // }
        },

        parcelas: {
            handler(value){
                this.$emit('parcelas', value)
            },
            deep: true
        },

        userInfo: {
            handler(value){
                if(value.cnpj) {
                    this.objNf.cnpj = value?.cnpj
                    this.getCnpjInfo(value?.cnpj)
                }
            },
            deep: true
        },

        ['objNf.ncm'](value){
            const searchNcm = this.itemsNcm.filter((ncm) => ncm.codigo === value)[0]
            this.objNf.cest = this.cests.filter((cest) => cest.descricao === searchNcm?.descricao)[0]?.codigo || this.objNf.cest
            this.componentKey += 1;
        },

        ['objNf.cest'](value){
            const searchCest = this.cests.filter((cest) => cest.codigo === value)[0]
            this.objNf.ncm = this.itemsNcm.filter((ncm) => ncm.descricao === searchCest?.descricao)[0]?.codigo || this.objNf.ncm
            this.componentKey += 1;
        },
    },
    async created() {

        this.transportadoras = await this.getDataEntity('Fornecedor')

        await Promise.all([
            //this.getOperacaoFiscalOptions(),
            this.getCFOPs(),
            this.getNcms(),
            this.getCests(),
        ]);

    }
}
</script>